module.exports = __webpack_public_path__ + "static/img/t1.01a260a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/draw/t1.png
// module id = 9BG6
// module chunks = 1